import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { MenuService } from '@app/_services';
import { PublicacionesService } from '@app/_services/publicaciones.service';
import { IdiomasService } from '@app/_services/idiomas.service';
import { AplicacionesService } from '@app/_services/aplicaciones.service';
import { Idioma } from '@app/_models/idioma';
import {
  Evento,
  EventoModel,
  EventoTraduccion,
  Recurrencia,
} from '@app/_models/evento';
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import { AlertService } from '@app/_services';
import { EventosService } from '@app/_services/eventos.service';
import { App } from '@app/_models/app';
import { Registro } from '@app/_models/registro';

@Component({
  selector: 'app-eventos-crear',
  templateUrl: './eventos-crear.component.html',
})
export class EventosCrearComponent implements OnInit {
  //Listas
  listaIdiomas: Idioma[] = [];
  listaIdiomasTotales: Idioma[] = [];
  listaTraducciones: Idioma[] = [];
  listaRecurrencias: Recurrencia[] = [];

  listaApps: App[] = [];
  listaAppsFilter: App[] = [];
  listaSeleccionados: App[] = [];

  //Traducciones
  listaTraduccionesEnviar: EventoTraduccion[] = [];
  //Data
  titulo: string = '';
  cuerpo: string = '';
  imagenB64: string = '';
  selectedIdioma: Idioma;
  selectedIdiomaPrueba: Idioma;

  selectedRecurrencia: Recurrencia = new Recurrencia();
  isAllDay: boolean;
  isRecurrente: boolean;

  myEvento: Evento = new Evento();
  myModel: EventoModel = new EventoModel();
  filePath: string;
  public fechaInicio: Date = new Date();
  public fechaFin: Date = new Date();
  public horaInicio: Date = new Date();
  public horaFin: Date = new Date();
  public format = 'dd/MM/yyyy HH:mm';
  idOrg: string;
  lang;
  private translate: TranslateService;

  constructor(
    private eventoService: EventosService,
    private idiomaService: IdiomasService,
    private appService: AplicacionesService,
    private menuService: MenuService,
    public router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    translate: TranslateService,
    private translateService: TranslateService
  ) {
    this.translate = translate;
    this.menuService.titulo = this.translate.instant('eventos.cabecera');
    this.idOrg = this.route.snapshot.params['idorg'];
    this.loadIdiomas();
  }

  ngOnInit(): void {
    this.lang = this.translateService.getDefaultLang();
    this.idiomaService.GetAll().subscribe((result) => {
      this.listaIdiomasTotales = result.data;
      console.log('Cargados idiomas = ' + this.listaIdiomasTotales.length);
      this.listaIdiomasTotales.forEach((x) => {
        const trad = new EventoTraduccion();
        trad.filled = false;
        trad.idIdioma = x.codigo;
        trad.nombreIdioma = x.nombre;
        this.listaTraduccionesEnviar.push(trad);
      });
    });
    //Get Apps
    this.appService.getAllApps().subscribe((result) => {
      console.log(result);
      this.listaApps = result.data;
      this.listaAppsFilter = this.listaApps;
    });
    //Get Recurrencias
    this.listaRecurrencias = this.eventoService.getRecurrencias();
  }

  loadIdiomas() {
    this.idiomaService.GetAll().subscribe((result) => {
      this.listaIdiomas = result.data;
      if (this.listaIdiomas.length > 0)
        this.selectedIdioma = this.listaIdiomas[0];
    });
  }

  btnCrearEvento() {
    console.log('Creando Evento');
    //Validación de los datos
    if (this.listaTraducciones.length <= 0) {
      this.alertService.warn(
        this.translateService.instant('eventos.errortrads')
      );
      return;
    }

    if (this.fechaInicio > this.fechaFin) {
      this.alertService.warn(
        this.translateService.instant('eventos.fechaerror')
      );
      return;
    }

    //AutoCompletado de Idiomas
    //seleccionado
    let seleccionado: EventoTraduccion = new EventoTraduccion();
    let encontrado: boolean = false;
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (trad.filled && !encontrado) {
        seleccionado = trad;
        encontrado = true;
        return;
      }
    });
    //Fill UnFilled
    this.listaTraduccionesEnviar.forEach((trad) => {
      if (!trad.filled) {
        trad.titulo = seleccionado.titulo;
        trad.cuerpo = seleccionado.cuerpo;
      }
    });

    console.log(this.listaTraduccionesEnviar);
    //Subir Foto  y EnviarNoticia
    this.myEvento.idCategoria = 1;
    this.myEvento.categoria = 'Patrocinado';
    this.myEvento.idOrg =  '00000000-0000-0000-0000-000000000000';
    
    console.log('Configurando Fechas...');
    this.myEvento.fechaInciio = new Date(
      this.fechaInicio.getFullYear(),
      this.fechaInicio.getMonth(),
      this.fechaInicio.getDate(),
      this.horaInicio.getHours(),
      this.horaInicio.getMinutes(),
      this.horaInicio.getSeconds()
    );
    this.myEvento.fechaFin = new Date(
      this.fechaFin.getFullYear(),
      this.fechaFin.getMonth(),
      this.fechaFin.getDate(),
      this.horaFin.getHours(),
      this.horaFin.getMinutes(),
      this.horaFin.getSeconds()
    );

    this.myEvento.mes = this.fechaInicio.getMonth();
    this.myEvento.dia = this.fechaInicio.getDate();
    this.myEvento.diasemana = this.fechaInicio.getDay() + 1;
    console.log('Recurrencias...');
    console.log(this.selectedRecurrencia);
    this.myEvento.recurrenciaAnual = this.selectedRecurrencia.id == 1;
    this.myEvento.recurrenciaMensual = this.selectedRecurrencia.id == 2;
    this.myEvento.recurrenciaSemanal = this.selectedRecurrencia.id == 3;
    this.myEvento.recurrenciaDiario = this.selectedRecurrencia.id == 4;
    this.myEvento.fotoUrl = this.filePath.split(',')[1]; //Borramos cabecera data: base64

    this.myModel.evento = this.myEvento;
    this.myModel.listaTraducciones = this.listaTraduccionesEnviar;
    this.eventoService.crearEvento(this.myModel).subscribe((result) => {
      if (!result.error) {
        this.alertService.success(
          this.translateService.instant('eventos.success')
        );

        let idNoticiaPatrocinador: number = result.codigo;
        this.myEvento.idEventoPatrocinador = idNoticiaPatrocinador;
        //Creación en Apps
        console.log(' -- Enviando A APPS -- ');
        this.listaSeleccionados.forEach((app) => {
          console.log('Enviando a ' + app.nombre);
          this.eventoService
            .sendPublicacionToApp(this.myModel, app)
            .subscribe((resultApp) => {
              console.log('Resultado:');
              console.log(resultApp);
              console.log('Enviando Registro '+app.nombre);
              let regTmp: Registro = new Registro();
              regTmp.error = false;
              regTmp.idApp = app.id;
              regTmp.idPublicacion = idNoticiaPatrocinador;
              if(resultApp.error)regTmp.error = true;
              this.eventoService
                .registrarPublicacionesApps(regTmp)
                .subscribe((resultreg) => {
                  console.log(
                    'Lista Publicaciones a App '+app.nombre+' registrada'
                  );
                });

            });
        });
        return;
      } else {
        this.alertService.error(this.translateService.instant('eventos.error'));
        return;
      }
    });
  }

  btnAddTraduccion() {
    console.log('Comprobando datos');
    if (
      this.selectedIdioma == null ||
      this.titulo.length <= 0 ||
      this.cuerpo.length <= 0
    ) {
      if (this.listaTraducciones.length <= 0) {
        this.alertService.info(
          this.translateService.instant('eventos.validacion')
        );
        return;
      }
    }
    console.log('Datos validados --->');
    if (!this.listaTraducciones.includes(this.selectedIdioma)) {
      this.listaTraducciones.push(this.selectedIdioma);

      this.listaTraduccionesEnviar.map((x) => {
        if (x.idIdioma == this.selectedIdioma.codigo) {
          x.filled = true;
          x.titulo = this.titulo;
          x.cuerpo = this.cuerpo;
        }
      });
    } else {
      console.log('Idioma ya añadido');
    }

    console.log(this.listaTraduccionesEnviar);
  }

  btnDeleteTraduccion(idioma: Idioma) {
    console.log(idioma);
    this.listaTraducciones = this.listaTraducciones.filter(
      (x) => x.codigo != idioma.codigo
    );

    this.listaTraduccionesEnviar.map((x) =>
      x.idIdioma == idioma.codigo ? (x.filled = false) : console.log()
    );

    console.log(this.listaTraduccionesEnviar);
  }

  getIdiomaFromReus(idioma) {
    //console.log('Llega Idioma');
    //console.log(idioma);
    this.selectedIdioma = idioma;
  }

  //Imagen

  imagePreview(e) {
    const file = (e.target as HTMLInputElement).files[0];
    const reader = new FileReader();
    reader.onload = () => {
      this.filePath = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  btnCancelar() {
    this.router.navigate(['eventos']);
  }

  handleFilter(query: string) {
    if (query.length > 1) {
      this.listaAppsFilter = this.listaApps.filter(
        (s) => s.nombre.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    } else if (query.length == 0) {
      this.listaAppsFilter = this.listaApps;
    }
  }
}
